import { Flex } from '@mantine/core';
import { useNavigate, useParams } from 'react-router';
import { useEpic } from '../../../api/tasks-client/tasks-client.hooks';
import { useTranslation } from 'react-i18next';
import { isSafeUrl } from '../../../helpers/general-helpers';
import { baseWhite, secondaryBase } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { Tooltip } from '../../../ui-library/tooltip/tooltip';
import { Text } from '../../../ui-library/typography/typography';

export const EpicDetailsHeader = () => {
  const i18n = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const { epic } = useEpic(id);

  return (
    <Flex align="center" gap={16}>
      <Button
        variant="secondary"
        radius="xl"
        size="sm"
        leftSection={<Icon name="arrow_back" size={18} color={baseWhite} />}
        onClick={() => navigate(-1)}
      >
        {i18n.t('strategy.initiatives.back')}
      </Button>

      {epic && (
        <Flex align="center" gap={8}>
          <Text size="large" weight="medium" color={secondaryBase}>
            {epic.key}
          </Text>
          {epic.url && (
            <Tooltip variant="white" label={i18n.t('common.visit_source_page')} position="right" zIndex={1000}>
              <Icon
                name="arrow_outward"
                size={24}
                color={secondaryBase}
                pointer
                onClick={() => {
                  if (!epic.url || !isSafeUrl(epic.url)) {
                    return;
                  }

                  window.open(epic.url, '_blank', 'noopener, noreferrer');
                }}
              />
            </Tooltip>
          )}
        </Flex>
      )}
    </Flex>
  );
};
